var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeConnecting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 88,
    viewBox: "0 0 185 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.793 22.6858L133.626 17.0356L133.427 28.208L146.793 22.6858Z",
    fill: "url(#paint0_linear_401_25364)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.75 29.0871H132.746L132.94 18.1494L120.78 45.1799L128.144 41.6507L132.75 29.0871Z",
    fill: "url(#paint1_linear_401_25364)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.094 24.2346L167.853 8.06497L140.893 4.0791L148.037 22.4209L156.094 24.2346Z",
    fill: "url(#paint2_linear_401_25364)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.876 75.5517L143.744 82.3755L166.826 83.6941L169.567 71.1689L140.876 75.5517Z",
    fill: "url(#paint3_linear_401_25364)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.078 46.3999L109.626 57.9478L142.809 81.8801L137.132 68.3734L120.078 46.3999Z",
    fill: "url(#paint4_linear_401_25364)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.203 22.1263L140.203 4.15576L108.12 20.6625L133.342 16.1774L147.203 22.1263Z",
    fill: "url(#paint5_linear_401_25364)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.738 16.9712L106.949 21.5545L109.389 57.2097L119.816 45.6916L132.738 16.9712Z",
    fill: "url(#paint6_linear_401_25364)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.365 51.3206H180.204L183.292 45.2608L173.382 38.1084L173.365 51.3206Z",
    fill: "url(#paint7_linear_401_25364)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.6 83.2889L179.35 61.4946L179.963 52.8486L170.311 70.8789L167.6 83.2889Z",
    fill: "url(#paint8_linear_401_25364)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.807 70.4052L179.659 51.9951H173.06L156.902 69.2828L169.807 70.4052Z",
    fill: "url(#paint9_linear_401_25364)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.382 37.255V37.2849L183.601 44.6549L184.858 42.1968L168.391 8.46631L156.717 24.5207L173.382 37.255Z",
    fill: "url(#paint10_linear_401_25364)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.619 45.9991L137.001 67.1148L128.19 42.376L120.619 45.9991Z",
    fill: "url(#paint11_linear_401_25364)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.306 69.9187L137.936 68.5659L140.609 74.9117L167.164 70.8533L156.319 69.9059L156.306 69.9187Z",
    fill: "url(#paint12_linear_401_25364)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.44615,
    y: 1.5775,
    width: 43.3291,
    height: 85.2376,
    rx: 5.6825,
    fill: "#5E66A5",
    fillOpacity: 0.6,
    stroke: "#5E66A5",
    strokeWidth: 1.42063
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0322 35.3628C74.224 37.0181 76.4048 40.3525 76.4048 44.1963C76.4048 48.04 74.224 51.3744 71.0323 53.0297L72.0797 54.0771C75.5115 52.1212 77.8254 48.429 77.8254 44.1963C77.8254 39.9635 75.5115 36.2713 72.0797 34.3154L71.0322 35.3628ZM75.1733 57.1707L76.1953 58.1927C80.6155 55.1126 83.5079 49.9922 83.5079 44.1963C83.5079 38.4003 80.6155 33.2799 76.1952 30.1998L75.1732 31.2218C79.3437 34.0279 82.0873 38.7917 82.0873 44.1963C82.0873 49.6008 79.3437 54.3646 75.1733 57.1707ZM79.2472 61.2446L80.2612 62.2587C85.6895 58.1049 89.1907 51.5594 89.1907 44.1962C89.1907 36.833 85.6895 30.2876 80.2612 26.1338L79.2472 27.1478C84.4225 31.0356 87.77 37.225 87.77 44.1962C87.77 51.1675 84.4225 57.3569 79.2472 61.2446Z",
    fill: "#5E66A5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_25364",
    x1: 125.268,
    y1: -15.7831,
    x2: 152.325,
    y2: -11.0925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_401_25364",
    x1: 113.357,
    y1: -61.2524,
    x2: 138.606,
    y2: -59.6064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_401_25364",
    x1: 124.436,
    y1: -55.1275,
    x2: 178.615,
    y2: -44.6255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_401_25364",
    x1: 123.363,
    y1: 34.3764,
    x2: 177.248,
    y2: 52.2629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_401_25364",
    x1: 89.3711,
    y1: -57.8228,
    x2: 157.312,
    y2: -48.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_401_25364",
    x1: 84.2635,
    y1: -48.6325,
    x2: 158.393,
    y2: -25.2701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_401_25364",
    x1: 91.207,
    y1: -101.229,
    x2: 144.519,
    y2: -96.2776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_401_25364",
    x1: 167.305,
    y1: -0.702461,
    x2: 187.762,
    y2: 1.52491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_401_25364",
    x1: 160.053,
    y1: -36.5693,
    x2: 185.743,
    y2: -35.0572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_401_25364",
    x1: 143.012,
    y1: -2.08435,
    x2: 188.986,
    y2: 6.15047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_401_25364",
    x1: 139.54,
    y1: -97.8374,
    x2: 197.48,
    y2: -91.3084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_401_25364",
    x1: 110.619,
    y1: -30.2941,
    x2: 144.466,
    y2: -27.0463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_401_25364",
    x1: 120.095,
    y1: 49.9252,
    x2: 162.256,
    y2: 78.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E66A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E66A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeConnecting);
export default __webpack_public_path__ + "static/media/home-connecting.a1d5b059459c5834a75e8c82ce18b32b.svg";
export { ForwardRef as ReactComponent };